import { render, staticRenderFns } from "./Register.success.vue?vue&type=template&id=66c6338f&scoped=true&lang=pug&"
import script from "./Register.success.vue?vue&type=script&lang=ts&"
export * from "./Register.success.vue?vue&type=script&lang=ts&"
import style0 from "./Register.success.vue?vue&type=style&index=0&id=66c6338f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c6338f",
  null
  
)

export default component.exports